import { SRPOption } from 'src/types/srp-options';

export const srpOptions: { [key: string]: SRPOption } = {
  promoPrice: { name: 'Promo Price', value: '0%' },
  srp: { name: 'SRP', value: '12%' }
  // with2307: { name: 'With 2307', value: '-1%' },
  // srpWith2307: { name: 'SRP + 2307', value: '11%' }
};
